<template>
  <div class="pledge-page-container">
    <div class="pledge-form-wrapper">
      <PledgeForm :is-page="true" @back="goBack" @close="onPledgeSubmitted" />
    </div>
  </div>
</template>

<script>
import PledgeForm from "@/components/PledgeForm.vue";

export default {
  name: "PledgeView",
  components: {
    PledgeForm,
  },
  methods: {
    goBack() {
      this.$router.push("/");
    },
    onPledgeSubmitted() {
      // After successful submission, redirect home or show a thank you page
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.pledge-page-container {
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f8f9fa;
  min-height: 80vh;
}

.pledge-form-wrapper {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 1200px;
}
</style>
